import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { EncryptDecryptService } from "../encrypt-decrypt.service";

@Injectable({
  providedIn: "root",
})
export class AboutUsService {
  constructor(
    private http: HttpClient,
    private encDecService: EncryptDecryptService
  ) {}

  GetTeamMembers(StaffID) {
    return this.http.get(
      environment.configUrl +
        "Staff/GetAllStaffPatient?StaffID=" +
        this.encDecService.enc(StaffID.toString()) +
        "&ArchiveFlag=0&CurrentDate=" +
        new Date()
    );
  }

  sendMassEmails(emailData) {
    var data = { EmailData: this.encDecService.enc(JSON.stringify(emailData)) };
    return this.http.post<any>(
      environment.configUrl +
        "EmailTemplate/SendMassEmailsPatient?CurrentDate=" +
        new Date(),
      data
    );
  }

  GetBannerDetails(PageName) {
    return this.http.get(
      environment.configUrl +
        "Banner/GetBannerDetails?PageName=" +
        PageName +
        "&CurrentDate=" +
        new Date()
    );
  }
}
